module.exports = __webpack_public_path__ + "statics/img/23.6c48f04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/technological/23.png
// module id = yFQ8
// module chunks = 1